import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=b67e5e7c&scoped=true&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=b67e5e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e5e7c",
  null
  
)

export default component.exports